<app-payment-link *ngIf="english"></app-payment-link>
<app-payment-link-hindi *ngIf="hindi"></app-payment-link-hindi>